import { pxToRem, scrollbar, themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { PleditorContainer, PleditorSidebar } from '../../../styled';
export const RHContainer = styled(PleditorContainer) `
  display: none;
  overflow: hidden;
  padding-bottom: 0;
  height: 100%;
  width: 100%;

  .ck.ck-editor__top.ck-reset_all {
    display: none;
  }

  .ck.ck-editor__main {
    min-width: ${pxToRem(823)}; /* Taken from the document's rendered width */
    min-height: 100%;
    height: 100%;
    overflow: auto;

    ${scrollbar({ trackMargin: 'xl' })};

    & > .ck-content {
      border-color: transparent;
    }
  }
`;
export const RHContentContainer = styled.div `
  width: fit-content;
  display: block;
  margin: 0 auto;
  height: 100%;
`;
export const RHContentInnerContainer = styled.div `
  display: inline-flex;
  justify-content: space-between;
  height: 100%;
`;
export const RHSidebar = styled(PleditorSidebar) `
  height: 100%;
  overflow: auto;
  color: ${themeGet('colors.text.300')};

  ${scrollbar({ trackMargin: 'xl' })};

  /* Revision History Sidebar Header */
  .ck-revision-history-sidebar__header {
    border-bottom: unset;
    padding-left: ${themeGet('spacing.2xl')};
  }

  /* Revision History Sidebar */
  .ck.ck-revision-history-sidebar {
    height: 100%;
  }

  /* Revision History Sidebar Revision Items Wrapper */
  .ck.ck-revision-history-sidebar .ck-revision-history-sidebar__timeline {
    padding-left: ${themeGet('spacing.2xl')};
    padding-right: ${themeGet('spacing.2xl')};
  }

  /* Revision History Sidebar Time Period */
  .ck.ck-revision-history-sidebar__time-period .ck-revision-history-sidebar__time-period__label {
    text-transform: capitalize;
    padding: 0;
    background-color: transparent;
    font-size: ${themeGet('fontSize.small')};
    font-weight: ${themeGet('fontWeight.medium')};
    color: ${themeGet('colors.text.200')};
  }

  /* Revision History Sidebar Revision Item */
  .ck .ck-revision-history-sidebar__revision-wrapper .ck-revision-history-sidebar__revision {
    border-radius: ${themeGet('borderRadius.md')};
    border: solid ${pxToRem(1)} ${themeGet('colors.gray.200')};
    cursor: pointer;
    color: ${themeGet('colors.text.300')};
    padding: ${themeGet('spacing.md')};
    box-shadow: none;
  }

  /* Revision History Sidebar Revision Item Selected */
  .ck
    .ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision.ck-revision-history-sidebar__revision_selected {
    background-color: ${themeGet('colors.background.100')};
  }

  /* Revision History Sidebar Revision Item Dropdown Button */
  .ck .ck-revision-history-sidebar__revision .ck-revision-history-sidebar__revision__actions .ck-dropdown__button {
    background: transparent;
    border-radius: ${themeGet('borderRadius.md')};
  }

  /* Revision History Sidebar Revision Item Dropdown Button Icon */
  .ck
    .ck-revision-history-sidebar__revision
    .ck-revision-history-sidebar__revision__actions
    .ck-dropdown__button
    .ck-button__icon {
    transform: scale(1);
  }

  /* Revision History Sidebar Revision Item Dropdown Item */
  .ck .ck-revision-history-sidebar__revision .ck-dropdown__panel {
    color: ${themeGet('colors.text.300')};
  }

  /* Revision History Sidebar Revision Item Authors Icon */
  .ck.ck-revision-history-sidebar__revision-authors .ck-icon {
    display: none;
  }

  /* Revision History Sidebar Revision Item Authors */
  .ck.ck-revision-history-sidebar__revision-authors {
    --ck-revision-history-revision-author-icon-offset: 0;
  }

  /* Revision History Sidebar Revision Item Authors Name */
  .ck.ck-revision-history-sidebar__revision-author .ck-revision-history-sidebar__revision-author__name {
    color: ${themeGet('colors.text.100')};
    font-weight: ${themeGet('fontWeight.regular')};
  }

  /* Revision History Sidebar Revision Item Date */
  .ck.ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision
    .ck-revision-history-sidebar__revision__date {
    font-size: ${themeGet('fontSize.tiny')};
    font-weight: ${themeGet('fontWeight.regular')};
    color: ${themeGet('colors.text.100')};
  }

  /* Revision History Sidebar Revision Item Controls Wrapper */
  .ck.ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision
    .ck-revision-history-sidebar__revision__controls-wrapper {
    margin: 0;
    font-size: ${themeGet('fontSize.tiny')};
  }

  /* Revision History Sidebar Revision Item Name */
  .ck.ck-revision-history-sidebar__revision-name > .ck-labeled-field-view__input-wrapper > .ck-input {
    font-weight: ${themeGet('fontWeight.regular')};
    color: ${themeGet('colors.text.300')};
    font-size: ${themeGet('fontSize.small')};
  }

  /* Revision History Sidebar Revision Item Name Selected */
  .ck.ck-revision-history-sidebar__revision-wrapper
    .ck-revision-history-sidebar__revision.ck-revision-history-sidebar__revision_selected
    .ck-revision-history-sidebar__revision-name
    .ck-input {
    color: inherit;
  }

  /* Revision History Sidebar Revision Item Dropdown Button */
  .ck.ck-revision-history-sidebar__revision .ck-revision-history-sidebar__revision__actions {
    top: ${themeGet('spacing.md')};
    right: ${themeGet('spacing.md')};
    display: block;

    & > button {
      cursor: pointer;
      background: transparent;
      transition: background 175ms ease-in-out;

      &:hover,
      &.ck-dropdown__button.ck-on {
        background: ${themeGetColor('gray.1000', 0.15)} !important;
      }
    }
  }

  /* Revision History Sidebar Revision Item Dropdown Button Icon */
  .ck.ck-icon.ck-icon_inherit-color {
    color: ${themeGet('colors.gray.600')};
  }
`;
export const RHEditor = styled.div ``;
